import { ModuleBase } from "@/modules/base";
import { RingsTract } from '@/modules/TractModule/RingsTract';
import { deg2rad } from '@hscmap/angle';
import { Component, Mixins } from 'vue-property-decorator';
import TractFrame from "./TractFrame";
import TractNumber from "./TractNumber.vue";
import { store } from '@/store';

@Component
export class TractModule extends Mixins(ModuleBase) {
  show = false
  showPatch = true
  rt!: RingsTract
  nw = 3
  nh = 3

  created() {
    this.rt = new RingsTract(120)
  }

  goto(index: number) {
    const [a, d] = this.rt.index2ad(index)
    store.currentGlobe().viewFactory.jumpTo({ phi: a, theta: d, fovy: deg2rad(1.5) })
  }

  get outlet() {
    return {
      overlayLayer: [TractFrame, TractNumber],
    }
  }
}
